var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: _vm.width + 'px'})},[_c('video-player',{attrs:{"options":Object.assign({}, _vm.defaultPlayerOption,
      {sources: [{
        src: _vm.source,  // 路径
        type: 'video/mp4'  // 类型
      }],
      poster: _vm.cover,
      aspectRatio: _vm.ratio})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }